module.exports = __webpack_public_path__ + "media/images/countrysquared/ao-bef2a1735bb543651fa9e409818460b5.svg";